import "./App.css";
import ToDo from "./components/ToDo";

function App() {
  return (
    <div>
      <ToDo />
    </div>
  );
}

export default App;
